import type { FaireProductEntity } from "../../entity_types/product";

export const p_8a86cnfc99: FaireProductEntity = {
  token: "p_8a86cnfc99",
  type: "product",
  name: "Li Hing Mui Mango",
  brandName: "Snack Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/360c68f24c5ee123743ff47fbfccde81523c627bc6c7582fea9f6748187013f9.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6378d217c33bfea2e04065f75e81d39bc40034b9bd8e6b41219dc53c8dd18736.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
